export default __webpack_public_path__ + "static/media/spark_56.4ca86c72.png";